import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjSubmit"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.58301 3.33333C1.58301 2.59695 2.17996 2 2.91634 2H7.91634C8.06473 2 8.20545 2.06591 8.30045 2.17991L10.2339 4.5H17.083C17.8194 4.5 18.4163 5.09694 18.4163 5.83333V16.6667C18.4163 17.4031 17.8194 18 17.083 18H2.91634C2.17997 18 1.58301 17.4031 1.58301 16.6667V3.33333ZM10.4416 7.59599L10.5889 7.74298L13.0889 10.2374L13.4133 10.5612C13.5599 10.7075 13.5602 10.9449 13.4139 11.0915L12.7665 11.7404C12.6202 11.887 12.3827 11.8873 12.2361 11.741L11.9117 11.4173L10.8336 10.3416V14.6912V15.0245C10.8336 15.3007 10.6098 15.5245 10.3336 15.5245H9.66695C9.39081 15.5245 9.16695 15.3007 9.16695 15.0245V14.6912V10.3447L8.08954 11.4221L7.76545 11.7462C7.61901 11.8927 7.38157 11.8927 7.23512 11.7462L6.58694 11.0981C6.4405 10.9516 6.4405 10.7142 6.58694 10.5677L6.91103 10.2436L9.41103 7.74363L9.55818 7.59648C9.80207 7.35259 10.1974 7.35238 10.4416 7.59599Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_Submit = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_Submit as default };
